module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Probe type","info":{"message":"According to the probe\u0027s datasheet, select one of the following options."}},"it":{"title":"Tipologia sonda","info":{"message":"Seleziona una delle opzioni disponibili in accordo con quanto indicato dal datasheet della sonda."}}}')
  delete Component.options._Ctor
}
